import i18n from 'i18n-js';
import { 
  SET_BARCODE_INPUT, 
  SET_PASS_SCAN,
  SET_CURRENT_ORDER, 
  SET_SCAN_ERROR, 
  SET_SCAN_SUCCESS, 
  SET_SUGGESTED_ITEM,
  SET_MAIN_INPUT_FOCUS,
  SET_PROMPT,
  SET_SERIAL_RECORD_ONE_INPUT,
  SET_SERIAL_RECORD_TWO_INPUT,
  SET_CART_SCAN_COMPLETE,
  SET_IS_EMPTY_CART,
  SET_CURRENT_CART_SCAN_COMPLETE,
  SET_PLACED_CONFIRMATION,
  SET_LAST_CART_INPUT,
  SET_SCAN_TO_CART_LOADING,
  SET_CART_TYPE_SCAN_STATE,
  SET_FOCUSED_ORDER,
  CLEAR_FOCUSED_ORDER,
  RESET_SCANPACK_ORDER,
} from '../constants';

import { navigate } from "../components/root_navigation"
import { ClearSearchProduct } from './productAction';
import { nextAdjacentScanCount, quantityAfterScanDeduction } from '../utils/sharedValidationUtils';
import { checkClickScanEnabled, checkIsActionBarCode, checkIsValidBarcode, checkProductInstructions, checkSerialRecordingEnabled, filterTotesWithPendingItems, findProductWithOrderItemId, getCurrentTote, getWrongScanLog, isNotFullFilledItem, notFullFilledUpdatedList, updateItemQty, updateScannedItemsList, updateTotePieceStatus, updateUnScannedItemsList, validateToteInput, checkToteOrderCompletion, validateToteForCurrentCart, checkIsRestartCode, getToteSummary, parseToteIdentifier, findOrderIdForTote, handleMatchedToteFlow, checkIfLastOrderPostScanning, orderHasUnresolvedNotFulfilled, checkCartTypeScanCode, getCartBulkScanLog, allocateTypeScanPieces, mergePendingPlacements } from '../components/scanToCartScanning/utils/scanningUtils';
import { changeSuggestedItem, getOrderById, handleCartOrdersUpdate, handleNextPickItem, handleToteAssignmentsUpdate, setIsCartView, setNextPickItem, setNotFullFilledItems, setPreviousNextPickItems, setScannedItems, setUnScannedItems, sortUnScannedItems, updateCartToteProgress, updateOrderProgress, updateScanLogs, extractToteAssignments, ReSetCartProgress, setToteAssignments, findToteForNextItem, handleCartData, setShowCartReadyBanner, setActiveTote } from './scanToCartActions';
import audioService from '../services/AudioService';
import { getPlaceQuantity, getProductRemainingCount } from '../components/scanToCartScanning/utils/scanProgressUtils';
import { SearchScanpackOrder, CallPostScanModule } from './scanpackAction';
import { runPostScanFlow } from '../utils/postScanning/postScanRunner';
import { createPostScanDriver } from '../utils/postScanning/createPostScanDriver';
import { getPostScanModules, getPostScanSteps } from '../utils/postScanning/postScanConfig';
import { processBarcodeInput } from '../components/ScanpackScanning/utils/barcodeProcessing';

export function setCurrentOrder(orderData) {
  return dispatch => {
    dispatch({
      type: SET_CURRENT_ORDER,
      payload: orderData
    });
  };
}

export function setBarcodeInput(barcodeValue) {
  return dispatch => {
    dispatch({
      type: SET_BARCODE_INPUT,
      payload: barcodeValue
    });
  };
}

export function setPassScan(isPassScan) {
  return {
    type: SET_PASS_SCAN,
    payload: isPassScan
  };
}

export function setScanSuccess(isSuccess) {
  return dispatch => {
    dispatch({
      type: SET_SCAN_SUCCESS,
      payload: isSuccess
    });
    setTimeout(()=>{
      dispatch({
        type: SET_SCAN_SUCCESS,
        payload: false
      });
    },120)
  };
}

export function setScanError(hasError) {
  return dispatch => {
    dispatch({
      type: SET_SCAN_ERROR,
      payload: hasError
    });
    setTimeout(()=>{
      dispatch({
        type: SET_SCAN_ERROR,
        payload: false
      });
    },120)
  };
}

export function setSuggestedItem(itemData) {
  return dispatch => {
    dispatch({
      type: SET_SUGGESTED_ITEM,
      payload: itemData
    });
  };
}

export function setCurrentCartScanComplete(value, messageKey = "scanToCart.scanningCompleted", redirect = true , showCloseIcon = false, celebrate = true) {
  return dispatch => {
    const setScanComplete = val =>
      dispatch({
        type: SET_CURRENT_CART_SCAN_COMPLETE,
        payload: {
          isVisible: val,
          messageKey: messageKey,
          showCloseIcon: showCloseIcon,
          celebrate
        }
      });

    if (value) {
      setScanComplete(true);

      setTimeout(() => {
        setScanComplete(false);
        if(redirect)
        {
          navigate('ScanPack');
        }
      }, 4000);

    } else {
      setScanComplete(false);
    }
  };
}

export function showNotFulfilledPromptForOrder(orderId) {
  return (dispatch, getState) => {
    const { notFullFilledItems } = getState().scanToCart;
    const orderNotFulfilled = notFullFilledItems.filter(nf => nf.order_id === orderId);
    const notFulfilledNames = orderNotFulfilled.map(nf => nf.name || nf.sku).filter(Boolean);
    dispatch(setPrompt(true, notFulfilledNames, 'out of stock'));
  };
}

export function processPickCompleteBarcode(barcodeValue, setIsLoading) {
  return async (dispatch, getState) => {
    const state = getState();
    const { toteAssignments, activeCart } = state.scanToCart;
    dispatch(setShowCartReadyBanner(false));

    const validationResult = validateToteForCurrentCart(barcodeValue, toteAssignments, activeCart);

    if (!validationResult) {
      await audioService.playNotReadySound();
      dispatch(setCurrentCartScanComplete(true, "pickComplete.processScanInstructions", false, true, false));
      return;
    }

    try {
      setIsLoading(true);
      dispatch(setLastCartInput(barcodeValue));

      const toteIdentifier = parseToteIdentifier(barcodeValue);
      const matchedOrderId = findOrderIdForTote(toteAssignments, toteIdentifier);

      if (matchedOrderId) {
        dispatch(setBarcodeInput(''));

        const scannedTote = toteAssignments.find(t => t?.tote_id?.toLowerCase() === toteIdentifier);
        if (scannedTote?.isPrinted) {
          setIsLoading(false);
          dispatch(setPrompt(true, barcodeValue, 'reprint'));
          return;
        }

        const { notFullFilledItems } = getState().scanToCart;
        if (orderHasUnresolvedNotFulfilled(notFullFilledItems, matchedOrderId)) {
          setIsLoading(false);
          await audioService.playNotReadySound();
          dispatch(showNotFulfilledPromptForOrder(matchedOrderId));
          return;
        }

        await handleMatchedToteFlow(dispatch, getState, {
          matchedOrderId,
          toteAssignments,
          barcodeValue,
          setIsLoading,
          SearchScanpackOrder,
          startPostScanningForOrder
        });
      } else {
        setIsLoading(false);
      }
    } catch (e) {
      console.error('ScanToCart: error in processPickCompleteBarcode:', e);
      setIsLoading(false);
    }
  };
}

export function setSerialRecordInput(type, value){
  return dispatch => {
    if(type === 1) {
      dispatch({
        type: SET_SERIAL_RECORD_ONE_INPUT,
        payload: value
      })
    }
    if(type === 2) {
      dispatch({
        type: SET_SERIAL_RECORD_TWO_INPUT,
        payload: value
      })
    }
  }
}

export const selectFocusedOrder = state => {
  const {focusedOrderId} = state.scanToCartScanning;
  if (focusedOrderId === null || focusedOrderId === undefined) return null;
  return state.scanToCart.cartOrders?.find(order => order.id === focusedOrderId) || null;
};

export function resetFocusedOrder() {
  return dispatch => {
    dispatch({type: CLEAR_FOCUSED_ORDER});
  };
}

export function setFocusedOrder(orderId) {
  return dispatch => {
    dispatch(setActiveTote(null));
    dispatch({type: SET_FOCUSED_ORDER, payload: orderId});
  };
}

function endFocusOnAcceptedScan() {
  return (dispatch, getState) => {
    if (getState().scanToCartScanning.focusedOrderId != null) dispatch(resetFocusedOrder());
  };
}

export function clearFocusedOrder() {
  return dispatch => {
    dispatch(setActiveTote(null));
    dispatch(resetFocusedOrder());
  };
}

export function resetScanStates() {
  return dispatch => {
    dispatch(setBarcodeInput(''));
    dispatch(setPassScan(false));
    dispatch(setScanSuccess(false));
    dispatch(setScanError(false));
    dispatch(setCurrentOrder(null));
    dispatch(setSuggestedItem(null));
    dispatch(setSerialRecordInput(1,''));
    dispatch(setSerialRecordInput(2,''));
    dispatch(setCartScanComplete(false));
    dispatch(handleIsEmptyCart(false));
    dispatch(setPlacedItemConfirmation(false));
    dispatch(setCartTypeScanState('', 0));
    dispatch(resetFocusedOrder());
  };
}

export function setMainInputFocus(hasFocus) {
  return dispatch => {
    dispatch({
      type: SET_MAIN_INPUT_FOCUS,
      payload: hasFocus
    });
  };
}

export  function setPrompt(isVisible, message, type) {
  return dispatch => {
    dispatch({
      type: SET_PROMPT,
      payload: {
        isVisible,
        message,
        type
      }
    });
  };
}

export function setCartTypeScanState(typeScanState, typeScanAdjacentScans) {
  return {
    type: SET_CART_TYPE_SCAN_STATE,
    payload: {typeScanState, typeScanAdjacentScans}
  };
}

function applyCartPickAllocation(count, logEvent) {
  return async (dispatch, getState) => {
    const {nextPickItem, unScannedItems, scannedItems, toteAssignments, cartOrders, previousNextPickItems} = getState().scanToCart;
    const {userInfo} = getState().user;

    const {allocations, workingUnScanned, workingScanned, workingTotes} = allocateTypeScanPieces(
      count,
      nextPickItem,
      unScannedItems,
      scannedItems,
      toteAssignments,
      (items, totes, productId) => findToteForNextItem(items, totes, productId)
    );

    if (allocations.length === 0) return false;

    dispatch(setUnScannedItems(workingUnScanned));
    dispatch(setScannedItems(workingScanned));
    dispatch(setToteAssignments(workingTotes));

    const updatedOrdersById = new Map();

    allocations.forEach(({item, tote, count: allocatedCount}) => {
      const order = updatedOrdersById.get(tote.order_id) || getOrderById(cartOrders, tote.order_id);
      if (order) {
        updatedOrdersById.set(tote.order_id, {
          ...order,
          scanned_items: updateScannedItemsList([...order.scanned_items], item),
          unscanned_items: updateUnScannedItemsList([...order.unscanned_items], item)
        });
        dispatch(updateScanLogs(
          getCartBulkScanLog(item, tote, allocatedCount, order.increment_id, userInfo?.name, logEvent)
        ));
      }
      dispatch(updateCartToteProgress(tote, 'picked', allocatedCount));
    });

    updatedOrdersById.forEach(updatedOrder => dispatch(handleCartOrdersUpdate(updatedOrder)));

    const activeOrderId = allocations[0].tote.order_id;
    const activeOrder = updatedOrdersById.get(activeOrderId) || getOrderById(cartOrders, activeOrderId);

    dispatch(setPreviousNextPickItems(mergePendingPlacements(previousNextPickItems, allocations)));
    dispatch(setNextPickItem({item: allocations[0].item, tote: allocations[0].tote}));
    dispatch(setCurrentOrder(activeOrder));
    dispatch(setIsCartView(true));
    dispatch(endFocusOnAcceptedScan());
    await handleScanSuccess(dispatch);
    return true;
  };
}

export function submitTypeScanCount(inputCount) {
  return async (dispatch, getState) => {
    const {typeScanAdjacentScans} = getState().scanToCartScanning;
    const {nextPickItem, toteAssignments} = getState().scanToCart;

    const currentItem = nextPickItem?.item;
    if (!currentItem || !nextPickItem?.tote) return;

    const typeScanCount = quantityAfterScanDeduction(parseInt(inputCount, 10) || 1, typeScanAdjacentScans);

    if (typeScanCount === 0) {
      dispatch(setCartTypeScanState(currentItem.sku, 0));
      dispatch(setPrompt(false, '', ''));
      return;
    }

    const scanUpToQty = getProductRemainingCount(currentItem.product_id, toteAssignments);
    if (scanUpToQty < typeScanCount || !(await dispatch(applyCartPickAllocation(typeScanCount, 'type_scan')))) {
      dispatch(setPrompt(true, i18n.t('scanpackItem.Scanpack_Item_Typecount_exceed_error'), 'alert'));
      await audioService.playErrorSound();
      return;
    }

    dispatch(setCartTypeScanState(currentItem.sku, 0));
    dispatch(setPrompt(false, '', ''));
  };
}

export function handleScanAllCart() {
  return async (dispatch, getState) => {
    const {nextPickItem, toteAssignments} = getState().scanToCart;

    const currentItem = nextPickItem?.item;
    if (!currentItem || !nextPickItem?.tote) return;

    const remainingForProduct = getProductRemainingCount(currentItem.product_id, toteAssignments);
    if (remainingForProduct <= 0 || !(await dispatch(applyCartPickAllocation(remainingForProduct, 'scan_all_items')))) {
      await handleScanError(dispatch);
      return;
    }

    dispatch(setCartTypeScanState(currentItem.sku, 0));
  };
}

const getGeneralSettings = getState => getState().user?.bothSettings?.data?.data?.general_setting;

export function handlePassButton() {
  return (dispatch, getState) => {
    const { nextPickItem } = getState().scanToCart;
    const { bothSettings, userInfo } = getState().user;

    const scanPackSettings = bothSettings?.data?.data?.scanpack_setting;
    const overridePassButton = userInfo?.override_pass_scanning;
    const currentItem = nextPickItem.item;
    const clickScanResult = checkClickScanEnabled(
      currentItem,
      scanPackSettings,
      overridePassButton
    );

    if (clickScanResult.showPrompt) {
      return dispatch(handleClickScan(clickScanResult));
    }

    const productConfirmationResult =  checkProductInstructions(currentItem, getGeneralSettings(getState));
    if (productConfirmationResult.showPrompt) {
      dispatch(setPrompt(true, productConfirmationResult.message, productConfirmationResult.type));
      return;
    }

    const serialRecordResult = checkSerialRecordingEnabled(currentItem);
    if (serialRecordResult.showPrompt && scanPackSettings?.require_serial_lot) {
      dispatch(setPrompt(true, serialRecordResult.message, serialRecordResult.type));
      return;
    }
    dispatch(processCurrentOrder(true));
  };
}

export function handlePromptCheckF1(){
  return (dispatch, getState) => {
    const { nextPickItem } = getState().scanToCart;
    const currentItem = nextPickItem.item;
    const productConfirmationResult =  checkProductInstructions(currentItem, getGeneralSettings(getState));
    if (productConfirmationResult.showPrompt) {
      dispatch(setPrompt(true, productConfirmationResult.message, productConfirmationResult.type));
      return;
    }

    const serialRecordResult = checkSerialRecordingEnabled(currentItem);
    if (serialRecordResult.showPrompt) {
      dispatch(setPrompt(true, serialRecordResult.message, serialRecordResult.type));
      return;
    }
    dispatch(processCurrentOrder());
  };
}

export function handlePromptCheckF2(){
  return (dispatch, getState) => {
    const { nextPickItem } = getState().scanToCart;
    const currentItem = nextPickItem.item;
    const serialRecordResult = checkSerialRecordingEnabled(currentItem);
    if (serialRecordResult.showPrompt) {
      dispatch(setPrompt(true, serialRecordResult.message, serialRecordResult.type));
      return;
    }
    dispatch(processCurrentOrder());
  };
}

export function handlePromptCheckF3(){
  return (dispatch, getState) => {
    const { nextPickItem } = getState().scanToCart;
    const currentItem = nextPickItem.item;

    const serialRecordResult = checkSerialRecordingEnabled(currentItem, true);
    if (serialRecordResult.showPrompt) {
      dispatch(setPrompt(true, serialRecordResult.message, serialRecordResult.type));
      return;
    }
    dispatch(processCurrentOrder());
  };
}

export function finalizePostScanning(toteInput = null, isReprint = false, orderId = null, isLastOrder = false) {
  return (dispatch, getState) => {
    try {
      dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: false });
      dispatch(setBarcodeInput(''));

      if (isReprint && toteInput) {
        const payload = { app: 'app', input: toteInput, scan_to_cart_enabled: true, state: 'scanpack.rfo', reprint: 'true' };
        dispatch(SearchScanpackOrder(payload, () => {}));
        return;
      }

      if (isLastOrder || !orderId) {
        dispatch(setCurrentCartScanComplete(true));
      }
      if (!orderId) {
        return;
      }

      const cartId = getState().scanToCart?.activeCart?.id;
      dispatch(CallPostScanModule('complete_post_scanning', orderId, null, null, { cart_id: cartId }, data => {
        const cart = data?.data?.cart;
        if (cart) {
          dispatch(handleCartData(cart));
        }
        if (data?.data?.cart_complete && !isLastOrder) {
          dispatch(setCurrentCartScanComplete(true));
        }
      }));
    } catch (e) {
      console.error('ScanToCart: error finalizing post-scanning', e);
      dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: false });
    }
  };
}

export function handleReScanOrderItemsModule(orderId, order, remainingModules, toteInput) {
  return async (dispatch, getState) => {
    if (!toteInput) {
      dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: false });
      console.error('No tote input available for re-scan order items');
      return;
    }

    const payload = {
      app: 'app',
      input: toteInput,
      scan_to_cart_enabled: true,
      state: 'scanpack.rfo',
      reset_item: true,
      _postScanningParams: remainingModules.length > 0 ? {
        postScanningContinue: true,
        postScanOrderId: orderId,
        postScanningModulesRemaining: remainingModules,
        postScanningToteInput: toteInput
      } : null
    };

    dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: true });
    try {
      await dispatch(SearchScanpackOrder(payload, () => {}));
    } finally {
      dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: false });
    }
  };
}


// `options` (fromShippingLabel / reprint) only affect finalize, so the config is
// built per call and closes over them.
export function scanToCartPostScanConfig(options = {}) {
  return {
    setLoading: (dispatch, value) =>
      dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: value }),

    packingCam: { returnParam: 'returnToScanToCart', carriesToteInput: true },

    showPrompt: (dispatch, { promptType, order, orderId, remainingModules, toteInput }) =>
      dispatch(setPrompt(true, {
        mode: promptType === 'PostScanRecordTracking' ? 'record' : 'verify',
        orderId,
        orderIncrementId: order?.increment_id,
        remainingModules,
        toteInput,
        // Without this the resume loses the flag, finalize re-searches the tote,
        // the backend answers 'Already printed' and the prompt re-opens forever.
        reprint: options?.reprint
      }, promptType)),

    reScanOrderItems: ({ order, orderId, remainingModules, toteInput }) =>
      handleReScanOrderItemsModule(orderId, order, remainingModules, toteInput),

    shippingLabel: {
      navigate: (dispatch, getState, { order, orderId, remainingModules, toteInput }) => {
        const userData = getState().user;
        navigate('ShippingLabel', {
          basicinfo: order,
          isolatedComponent: true,
          returnToScanToCart: true,
          currentOrderId: orderId,
          userRole: userData,
          directPrintingSetting: userData?.bothSettings?.data?.data?.general_setting?.print_ss_shipping_labels,
          postScanningContinue: true,
          postScanOrderId: orderId,
          postScanningModulesRemaining: remainingModules,
          postScanningToteInput: toteInput,
          onPrintPackingSlip: () => {
            dispatch(CallPostScanModule('print_packing_slip', orderId));
          }
        });
      }
    },

    finalize: ({ orderId, toteInput }) => (dispatch, getState) => {
      const { toteAssignments, cartOrders, unScannedItems } = getState().scanToCart;
      const isLastOrder = checkIfLastOrderPostScanning(toteAssignments, cartOrders, orderId, unScannedItems) || false;
      const shouldFinalize = options?.fromShippingLabel ? isLastOrder : (toteInput || isLastOrder);
      if (shouldFinalize) {
        dispatch(finalizePostScanning(toteInput, options?.reprint, orderId, isLastOrder));
      } else {
        dispatch(setBarcodeInput(''));
      }
    }
  };
}

export function startPostScanningForOrder(orderId, modules = [], toteInput = null, options = {}) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: true });
      const { scanToCart } = getState();
      const order = scanToCart?.cartOrders?.find(o => o.id === orderId);
      if (!order) {
        dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: false });
        return;
      }
      await dispatch(
        runPostScanFlow(createPostScanDriver(scanToCartPostScanConfig(options)), {
          order,
          orderId,
          modules,
          toteInput
        })
      );

      dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: false });
    } catch (error) {
      console.error('ScanToCart: error in startPostScanningForOrder', error);
      dispatch({ type: SET_SCAN_TO_CART_LOADING, payload: false });
    }
  };
}

export function handleClickScan(clickScanResult) {

  return dispatch => {
    if (clickScanResult.showPrompt && clickScanResult.type === 'ClickScanDisabled') {
      dispatch(setPrompt(true, clickScanResult.message, clickScanResult.type));
      setTimeout(() => {
        dispatch(setPrompt(false, '', ''));
      }, 3000);
      return;
    }

    if (clickScanResult.showPrompt && clickScanResult.type === 'ClickScanConfirmation') {
      dispatch(setPrompt(true, clickScanResult.message, clickScanResult.type));
      return;
    }
  };
}


export function handleBarcodeInput(isUpdated = false, input = '') {
  return async (dispatch, getState) => {
    dispatch(setPassScan(false));
    const { barcodeValue, currentOrder } = getState().scanToCartScanning;
    const { nextPickItem, isCartView, previousNextPickItems, toteAssignments, activeCart, unScannedItems, notFullFilledItems } = getState().scanToCart;
    const { userInfo, bothSettings } = getState().user;
    const scanPackSettings = bothSettings?.data?.data?.scanpack_setting;
    const isRestartCode = checkIsRestartCode(barcodeValue, scanPackSettings);
    if (isRestartCode) {
      dispatch(setPrompt(true, '', 'RestartConfirmation'));
      return;
    }
    const currentItem = nextPickItem.item;
    const typeScanResult = checkCartTypeScanCode(
      isUpdated ? input : barcodeValue,
      scanPackSettings,
      currentItem,
      getState().scanToCartScanning.typeScanState,
      unScannedItems
    );
    if (typeScanResult) {
      if (typeScanResult.showPrompt) {
        dispatch(setPrompt(true, typeScanResult.message, 'alert'));
        await audioService.playErrorSound();
      } else {
        dispatch(setPrompt(true, '', 'TypeScanCount'));
      }
      return;
    }
    const isNotFullFilled = isNotFullFilledItem(notFullFilledItems,currentItem);
    const currentTote = getCurrentTote(previousNextPickItems,toteAssignments, nextPickItem);
    const processedBarcode = processBarcodeInput(barcodeValue, scanPackSettings, false);
    const isValidBarcode = checkIsValidBarcode(processedBarcode, currentItem);
    if(isCartView){
      if(currentTote && validateToteInput(isUpdated ? input : barcodeValue, currentTote.tote_id, activeCart.cart_id)){
        let pickedPieceCount = getPlaceQuantity(currentTote);
        if(pickedPieceCount > 1 && !isUpdated){
          dispatch(setPlacedItemConfirmation(true));
          return
        }
        let updatedTote = updateTotePieceStatus(currentTote, "picked", "picked_and_placed", pickedPieceCount, false);
        dispatch(handleToteAssignmentsUpdate(updatedTote));
        if(previousNextPickItems.length > 1) {
          dispatch(setNextPickItem(previousNextPickItems[0]));
          dispatch(setPreviousNextPickItems(previousNextPickItems.slice(1)));
        } else {
          dispatch(setPreviousNextPickItems([]));
          dispatch(changeSuggestedItem(currentItem.product_id, true, true));
        }
        dispatch(updateCartToteProgress(updatedTote, 'picked_and_placed', pickedPieceCount));
        dispatch(setPlacedItemConfirmation(false));
        dispatch(endFocusOnAcceptedScan());
        await handleScanSuccess(dispatch);
        if(unScannedItems.length === 0 && !isNotFullFilled ) {
          dispatch(checkPendingTote());
          //TODO future handle the api call here for post scanning action 
        }
        return;
      }
      const scanUpToQty = getProductRemainingCount(currentItem.product_id, toteAssignments);
      if(scanUpToQty > 0 && isValidBarcode) {
        dispatch(handleViewItem(false));
        dispatch(handleBarcodeInput());
        return;
      }

      if(isUpdated){
        dispatch(setScanError(true));
        await audioService.playErrorSound();
        return
      }
      if(scanUpToQty == 0 || !isValidBarcode) {
        await handleScanError(dispatch);
        return;
      }
    }

    const isActionBarcode =  checkIsActionBarCode(barcodeValue);
    dispatch(setPassScan(isActionBarcode));
    if (isActionBarcode) {
      dispatch(handlePassButton());
      return;
    }

    if (!isValidBarcode) {
      const wrongScanLog = getWrongScanLog(barcodeValue, currentItem, nextPickItem.tote,currentOrder.increment_id, userInfo.name);
      dispatch(updateScanLogs(wrongScanLog));
      await handleScanError(dispatch);
      return;
    }

    if(currentItem.qty_remaining === 0 && !isNotFullFilled) {
      await handleScanError(dispatch);
      dispatch(setIsCartView(true));
      return
    }

    if(isNotFullFilled && currentItem.skipped_qty === 0) {
      await handleScanError(dispatch);
      dispatch(setIsCartView(true));
      return
    }

    const productConfirmationResult =  checkProductInstructions(currentItem, getGeneralSettings(getState));
    if (productConfirmationResult.showPrompt) {
      dispatch(setPrompt(true, productConfirmationResult.message, productConfirmationResult.type));
      return;
    }

    const serialRecordResult = checkSerialRecordingEnabled(currentItem);
    if (serialRecordResult.showPrompt) {
      dispatch(setPrompt(true, serialRecordResult.message, serialRecordResult.type));
      return;
    }
    dispatch(processCurrentOrder());
  };
}

export const handleScanSuccess = async (dispatch) => {
  dispatch(setMainInputFocus(false));
  dispatch(setScanSuccess(true));
  await audioService.playSuccessSound();
  dispatch(setBarcodeInput(''));
  dispatch(setMainInputFocus(true));
};

export const handleScanError = async (dispatch) => {
  dispatch(setMainInputFocus(false));
  dispatch(setScanError(true));
  await audioService.playErrorSound();
  dispatch(setBarcodeInput(''));
  dispatch(setMainInputFocus(true));
};

export const handleIsEmptyCart = (isEmpty) => {
  return (dispatch) => {
    dispatch({
      type: SET_IS_EMPTY_CART,
      payload: isEmpty
    });
  };
}

export function setCartScanComplete(isComplete) {
  return (dispatch) => {
    dispatch({
      type: SET_CART_SCAN_COMPLETE,
      payload: isComplete
    })
  };
}

export function setPlacedItemConfirmation(isPlaced) {
  return (dispatch) => {
    dispatch({
      type: SET_PLACED_CONFIRMATION,
      payload: isPlaced
    })
  };
}

export function processCurrentOrder(isActionBarcode = false) {
  return async(dispatch, getState) => {
    const state = getState();
    const { currentOrder, barcodeValue } = state.scanToCartScanning;
    const { item, tote } = state.scanToCart.nextPickItem;
    const { unScannedItems, scannedItems, notFullFilledItems } = state.scanToCart;

    if (!tote) {
      dispatch(setPassScan(false));
      const isNotFulfilledLine = isNotFullFilledItem(notFullFilledItems, item);
      const { toteAssignments, cartOrders } = state.scanToCart;
      const nextOpen = findToteForNextItem(isNotFulfilledLine ? notFullFilledItems : unScannedItems, toteAssignments, undefined, undefined, isNotFulfilledLine);
      if (nextOpen?.tote) {
        dispatch(setCurrentOrder(getOrderById(cartOrders, nextOpen.item.order_id)));
        dispatch(setNextPickItem(nextOpen));
      }
      dispatch(setPrompt(true, i18n.t(nextOpen?.tote ? 'scanToCart.toteFullScanNext' : 'scanToCart.toteFullNoOtherLine'), 'alert'));
      await handleScanError(dispatch);
      return;
    }

    const isNotFulfilled = isNotFullFilledItem(notFullFilledItems, item);
    const updatedItem = updateItemQty(item, isNotFulfilled);

    if (isNotFulfilled) {
      const scannedList = updateScannedItemsList([...scannedItems], updatedItem);
      const updatedNotFullList = notFullFilledUpdatedList(notFullFilledItems, updatedItem);
      const updatedTote = updateTotePieceStatus(tote);
      dispatch(updateOrderProgress(updatedItem,tote, barcodeValue,isNotFulfilled));
      dispatch(setScannedItems(scannedList));
      dispatch(setNotFullFilledItems(updatedNotFullList));
      dispatch(updateCartToteProgress(updatedTote));
      dispatch(handleNextPickItem(updatedItem, updatedTote));
      if(updatedNotFullList.length === 0) {
        dispatch(setIsCartView(true));
      }
      dispatch(endFocusOnAcceptedScan());
      await handleScanSuccess(dispatch);
      return;
    }

    const updatedTote = updateTotePieceStatus(tote);
    const updatedGlobalScannedItems= updateScannedItemsList([...scannedItems], updatedItem)
    const newScannedItems = updateScannedItemsList([...currentOrder.scanned_items], updatedItem);
    const newUnScannedItems = updateUnScannedItemsList([...currentOrder.unscanned_items], updatedItem);
    const updatedGlobalUnScannedItems = updateUnScannedItemsList([...unScannedItems], updatedItem);

    const updatedOrder = {
      ...currentOrder,
      unscanned_items: newUnScannedItems,
      scanned_items: newScannedItems
    };
    dispatch(updateCartToteProgress(updatedTote));
    dispatch(updateOrderProgress(updatedItem,updatedTote, barcodeValue));
    dispatch(setCurrentOrder(updatedOrder));
    dispatch(setUnScannedItems(updatedGlobalUnScannedItems));
    dispatch(setScannedItems(updatedGlobalScannedItems));
    dispatch(handleNextPickItem(updatedItem, updatedTote));
    dispatch(handleCartOrdersUpdate(updatedOrder));
    const {typeScanState, typeScanAdjacentScans} = getState().scanToCartScanning;
    dispatch(setCartTypeScanState(updatedItem.sku, nextAdjacentScanCount(typeScanState, typeScanAdjacentScans, updatedItem.sku)));
    dispatch(endFocusOnAcceptedScan());
    await handleScanSuccess(dispatch);
  };
}

export function handleViewItem(changeCartView = true) {
  return (dispatch, getState) => {
    const { nextPickItem, previousNextPickItems, toteAssignments } = getState().scanToCart;
    const { item, tote } = nextPickItem;
    const scanUpToQty = getProductRemainingCount(item.product_id, toteAssignments);
    if(item.scanned_qty === 0 || scanUpToQty === 0) {
      dispatch(setIsCartView(false));
      const { cartOrders } = getState().scanToCart;
      
      if(previousNextPickItems.length > 0 && item.qty_remaining == 0) {
        let itemToReplace = previousNextPickItems[0];
        if(itemToReplace.tote.id !== tote.id) {
          dispatch(setNextPickItem(previousNextPickItems[0]));
          dispatch(setCurrentOrder(getOrderById(cartOrders, previousNextPickItems[0].item.order_id)));
        } else if(itemToReplace.tote.id === tote.id) {
          const updatedPreviousNextPickItems = [...previousNextPickItems];
          updatedPreviousNextPickItems[0] = nextPickItem;
          dispatch(setPreviousNextPickItems(updatedPreviousNextPickItems));
          dispatch(setNextPickItem(nextPickItem));
          dispatch(setCurrentOrder(getOrderById(cartOrders, nextPickItem.item.order_id)));
        }
      }
      return;
    }
    let updatedPreviousNextPickItems;
    if(previousNextPickItems.length > 0) {
      const existingIndex = previousNextPickItems.findIndex(pickItem => 
        pickItem.item.product_id === item.product_id && 
        pickItem.item.order_item_id === item.order_item_id
      );
      if(existingIndex >= 0) {
        updatedPreviousNextPickItems = [...previousNextPickItems];
        updatedPreviousNextPickItems[existingIndex] = nextPickItem;
      } else {
        updatedPreviousNextPickItems = [...previousNextPickItems, nextPickItem];
      }
    } else {
      updatedPreviousNextPickItems = [nextPickItem];
    }
    dispatch(setPreviousNextPickItems(updatedPreviousNextPickItems));
    changeCartView && dispatch(setIsCartView(false));
    dispatch(changeSuggestedItem(item.product_id, true))
  };
}

export function checkPendingTote(cartScanComplete= true){
  return (dispatch, getState) => {
    const { toteAssignments, cartOrders } = getState().scanToCart;
    const pendingTotes = filterTotesWithPendingItems(toteAssignments)
    if(pendingTotes.length > 0) {
      const currentOrder = getOrderById(cartOrders, pendingTotes[0].order_id);
      const item = findProductWithOrderItemId(pendingTotes[0].product_id,pendingTotes[0].order_item_id,currentOrder.scanned_items)
      const nextPickItem = {
        item,
        tote: pendingTotes[0]
      }
      dispatch(setCurrentOrder(currentOrder));
      dispatch(setNextPickItem(nextPickItem));
      dispatch(setIsCartView(true));
    }
    else{
      if(!cartScanComplete) return false;
      dispatch(setCartScanComplete(true));
      dispatch(setIsCartView(true));
    }
  }
}

export function setLastCartInput(input) {
  return dispatch => {
    dispatch({
      type: SET_LAST_CART_INPUT,
      payload: input,
    })
  };
}


export function redirectToProductDetail(productId, page = 'ScanToCart') {
  return (dispatch, getState) => {
    const {currentOrder} = getState()?.scanToCartScanning;
    const userData = getState().user;
    dispatch(ClearSearchProduct());
    if (page === 'ScanToCart') dispatch(setMainInputFocus(false));
    navigate('ProductDetail', {
      productInfo: productId,
      orderID: currentOrder?.id,
      increment_id: currentOrder?.increment_id,
      userData: userData,
      page: page,
    });
  }
}

export function redirectToOrderDetail() {
  return (dispatch, getState) => {
    const { currentOrder } = getState().scanToCartScanning;
    const userData = getState().user;

    if (!currentOrder) {
      return;
    }

    dispatch(setMainInputFocus(false));

    // Use the order ID to let OrderDetail fetch complete data via API
    // This ensures all required data structure is properly loaded
    navigate('OrderDetail', {
      item: currentOrder, // Only pass ID to trigger API call
      userData: userData,
      page: 'ScanToCartScanning',
      onComeBack: () => {/* Optional: Handle return navigation*/},
      callOrder: currentOrder
    });
  };
}

export function handleToteOrderCompletionAndNavigation(updatedCart, scannedToteId) {
  return (dispatch, getState) => {
    try {
      // With v2 on, the module list alone decides whether the label screen opens
      // and where in the sequence, so this legacy path stands down.
      const { enabled } = getPostScanModules(getState());
      if (enabled) return;

      const toteAssignments = extractToteAssignments(updatedCart);
      const completionResult = checkToteOrderCompletion(toteAssignments, scannedToteId);

      if (completionResult.error) {
        console.error('Tote completion check error:', completionResult.error);
        return;
      }
      if (completionResult.isComplete) {
        dispatch(setPrompt(false, '', ''));
        dispatch(navigateToShippingLabels(completionResult.orderId));
      }

    } catch (error) {
      console.error('Error in handleToteOrderCompletionAndNavigation:', error);
    }
  };
}

function navigateToShippingLabels(orderId) {
  return (dispatch, getState) => {
    try {
      const { cartOrders } = getState().scanToCart;
      const { lastCartInput } = getState().scanToCartScanning || {};
      const userData = getState().user;

      const orderData = cartOrders?.find(order => order.id === orderId);

      if (!orderData || !orderData?.print_ss_label) {
        console.error('Order data not found for ID:', orderId);
        return;
      }

      const navigationData = {
        basicinfo: orderData,
        isolatedComponent: true,
        returnToScanToCart: true,
        currentOrderId: orderId,
        userRole: userData,
        directPrintingSetting: userData?.bothSettings?.data?.data?.general_setting?.print_ss_shipping_labels,
        postScanningContinue: true,
        postScanOrderId: orderId,
        postScanningModulesRemaining: [],
        postScanningToteInput: lastCartInput,
        postScanningFromShippingLabel: true,
        onPrintPackingSlip: () => {
          dispatch(CallPostScanModule('print_packing_slip', orderId));
        }
      };
      setTimeout(() => {
        navigate('ShippingLabel', navigationData);
      }, 2000)

    } catch (error) {
      console.error('Error navigating to shipping labels:', error);
    }
  };
}

export function navigateToScanPackItem(order, postScanningParams = null) {
  return (dispatch, getState) => {
    const { userInfo } = getState().user;
    if (!order) {
      console.error('No orders available in cart');
      return;
    }
    dispatch(setPrompt(false, '', ''));
    const navigationParams = {
      data: {
        from: 'scanToCart',
        order: order
      },
      userdata: userInfo
    };

    if (postScanningParams) {
      navigationParams.postScanningContinue = postScanningParams.postScanningContinue;
      navigationParams.postScanOrderId = postScanningParams.postScanOrderId;
      navigationParams.postScanningModulesRemaining = postScanningParams.postScanningModulesRemaining;
      navigationParams.postScanningToteInput = postScanningParams.postScanningToteInput;
    }

    // GROOV-5133: searchOrder can still hold an RFO error payload (or a stale valid
    // order) from before this navigation; clear it so scanpack_item.js reads the
    // route's order instead of a mismatched one.
    dispatch({ type: RESET_SCANPACK_ORDER });
    navigate('ScanPackItem', navigationParams);
  };
}

export function resumePendingReScan(order) {
  return (dispatch, getState) => {
    const toteInput = order?.tote;
    if (!toteInput) return false;
    const { steps } = getPostScanSteps(getState());
    const reScanIndex = steps.indexOf('re_scan_order_items');
    const remainingModules = reScanIndex >= 0 ? steps.slice(reScanIndex + 1) : [];
    dispatch(handleReScanOrderItemsModule(order.id, order, remainingModules, toteInput));
    return true;
  };
}

export function handleCartRestart(cartId) {
  return (dispatch) => {
    if (!cartId) {
      return;
    }

    dispatch(ReSetCartProgress(cartId, (input, successMessage) => {
      if (successMessage && successMessage.endsWith('reset successfully')) {
        navigate('ScanPack');
      }
    }));
  };
}
